<div class="user-list-detail-availability">
  <div class="mini-availability-percentage">
    {{ availabilityPercentage$ | async }}%
  </div>
  <div
    #availabilityTable
    class="mini-availability-table">
    <div class="no-overflow-table">
      <div
        class="table-row no-border"
        [attr.data-cy]="'mini-user-table-row-' + (user$ | async)?._id">
        <div
          *ngFor="
            let availabilityDate of availabilityDays$ | async;
            let i = index
          "
          class="table-cell"
          [class.first-weekday]="(availabilityDate | date: 'cc') === '1'"
          [style.--cellWidth]="(availabilityDayWidth$ | async) + 'px'"
          matTooltipPosition="above"
          [matTooltip]="(availabilityDate | date: 'dd.MM.yyy') || ''">
          <ng-container *ngIf="(availabilityDate | date: 'cc') === '1'">
            <div class="calendar-week">
              {{
                (("calendarWeekShort" | i18n) || "KW ") +
                  (availabilityDate | date: "ww")
              }}
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              i === 0 || i === ((availabilityDays$ | async) ?? []).length - 1
            ">
            <div
              class="availability-date"
              [class.first]="i === 0"
              [class.last]="
                i === ((availabilityDays$ | async) ?? []).length - 1
              ">
              {{ availabilityDate | date: "dd.MM" }}
            </div>
          </ng-container>
        </div>
        <ng-container
          *ngFor="
            let availability of employmentAvailabilitiesWithLength$ | async
          ">
          <div
            class="employment-availability"
            [class.available]="availability.status === statusEnum.AVAILABLE"
            [class.working]="availability.status === statusEnum.WORKING"
            [class.unavailable]="availability.status === statusEnum.UNAVAILABLE"
            [style.width.px]="
              availability.daysBetween * ((availabilityDayWidth$ | async) ?? 0)
            "
            [style.left.px]="
              availability.offset * ((availabilityDayWidth$ | async) ?? 0)
            ">
            <div
              *ngIf="
                availability.status === statusEnum.AVAILABLE &&
                availability.workload
              "
              class="employment-availability-tooltip-area"
              matTooltipPosition="above"
              [matTooltip]="
                availability.workload + '% ' + (('workload' | i18n) || 'Pensum')
              "></div>
            <p
              *ngIf="
                availability.status === statusEnum.AVAILABLE &&
                availability.workload
              "
              class="employment-availability-workload">
              {{ availability.workload }}%
              {{ ("workload" | i18n) || "Pensum" }}
            </p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
